Namespace 'VueInBackbone'

class VueInBackbone.VueApp extends Backbone.View

  initialize:(componentAppName, props) ->
    @componentAppName = componentAppName
    @store = Vue.Stores[@componentAppName]()
    @props = Vue.observable(@clone(props))
    @createVueInstance()

  render: ->
    @vueInstance.$options.render = (h) => h(@componentAppName, {props: @props})
    @vueInstance.$mount(@el)
    @

  createVueInstance: ->
    @vueInstance = new Vue({
      store: @store
    })

  on: (eventName, callback)->
    @handleEventForVueComponent(eventName)
    super(eventName, callback)

  handleEventForVueComponent: (eventName) ->
    wrapperView = @
    vueHandlerEvent = (args...) ->
        wrapperView.trigger(eventName, args...)
    @store.eventBus.$on(eventName, vueHandlerEvent)

  remove: ->
    @vueInstance.$destroy() if @vueInstance
    super()

  update: (props) ->
    for key, value of @clone(props)
      @props[key] = value

  clone: (props) ->
    JSON.parse(JSON.stringify(props))
